import React from 'react';
import './BasePageLayout.css';

interface BasePageLayoutProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'full' | 'none';
  background?: 'white' | 'gray' | 'gradient';
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const BasePageLayout: React.FC<BasePageLayoutProps> = ({ 
  children, 
  className = '', 
  maxWidth = 'lg',
  background = 'gray',
  padding = 'md'
}) => {  const maxWidthClass = {
    'sm': 'max-w-sm',
    'md': 'max-w-md', 
    'lg': 'max-w-lg',
    'xl': 'max-w-xl',
    'full': 'max-w-full',
    'none': 'max-w-none'
  }[maxWidth];

  const backgroundClass = {
    'white': 'bg-white',
    'gray': 'bg-gray',
    'gradient': 'bg-gradient'
  }[background];

  const paddingClass = {
    'none': 'p-none',
    'sm': 'p-sm',
    'md': 'p-md',
    'lg': 'p-lg'
  }[padding];

  return (
    <div className={`base-page-layout ${backgroundClass} ${paddingClass} ${className}`}>
      <div className={`page-container ${maxWidthClass}`}>
        {children}
      </div>
    </div>
  );
};

export default BasePageLayout;
